import React from 'react';
import { BsHeartFill } from 'react-icons/bs';

const Footer = () => {
    return(
        <footer>
            <div><h6>© Copyright Mat, 2021 --> Crafted with <BsHeartFill style={{fontSize: '0.8rem'}} /></h6></div>
        </footer>
    )
};

export default Footer;